/* eslint-disable semi */
import $ from 'jquery'
import Select2 from 'select2'


function init() {

    $(document).on('ready', function() {

        $('.filter-posts-dropdown').select2({
            minimumResultsForSearch : -1,
            width : 'resolve'
        })  
        .on('change', function() {

            let contain = $(this).closest('.wp-block-group')
            if( contain == null || contain == "" ) { contain = $(this).closest('.wp-block-cover') }
            if( contain == null || contain == "" ) { console.log('Parent Cover or Block not found for filter-posts-dropdown'); return; }
     
            let postgrid = contain.find('.postGrid')
     
            postgrid.stop().css( "opacity" , 0.6)
     
            let posttype = 'post'
            let postgrid_classes = postgrid.attr('class').split(/[ ]+/)
            postgrid_classes.forEach(c => {
                 if( c.indexOf('posttype-') != -1  )
                     posttype = c.split('posttype-').join('')
            })
     
            let state = this.value

            let displayoptions = []

            contain.find('input.post-display-options').each( function(index, elem) {
                displayoptions.push( $(elem).val() )
            })
     
            $.ajax({
                 url : WP.ajax_url,
                 type : 'post',
                 data : {
                     action : 'get_the_posts_by_state',
                     state : state,
                     displayoptions: displayoptions,
                     posttype : posttype
                 },
                 success : function( response ) {
                     postgrid.html(response)
                     postgrid.stop().fadeTo( "fast" , 1)
                 }
            })
     
        })

     })

}
  
export default {
    init,
}

  